import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

type ButtonType = "YesNo" | "OkCancel" | "Ok" | "YesNoCancel" |'tag'|'send'|'sendEmail'|'priceChange'|'ref';

export interface MsgBoxItems {
  msg: string;
  title: string;
  buttonType : ButtonType
}

@Injectable({
  providedIn: 'root'
})
export class DialogService {
  subMsgItem!: Subject<MsgBoxItems>;
  subResult!: Subject<string>;
  observable!: any;
  onResAction? : Function
  constructor() { 
    this.subMsgItem = new Subject<MsgBoxItems>();
    this.subResult = new Subject<string>();

  }
  
  open(msgItms: MsgBoxItems) {
    this.subMsgItem.next(msgItms);
  }

  getMsgSub() {
    return this.subMsgItem.asObservable();
  }

  result(res: string) {
    if (this.onResAction) {
      this.onResAction(res);
    }  
  }

  onResponse(fn: Function) {
    this.onResAction = fn;
  }

}
